import { createRequestTypes } from 'appUtils';

export const FETCH_LOCATIONS_BY_TEAM_MEMBERSHIP = createRequestTypes(
  'FETCH_LOCATIONS_BY_TEAM_MEMBERSHIP'
);

export const CREATE_OR_UPDATE_ENTITY_LOCATION = createRequestTypes(
  'CREATE_OR_UPDATE_ENTITY_LOCATION'
);
